import React from 'react'
import { ReactComponent as ImagePosition } from '../../../assets/images/jobDetail/position.svg';
import { ReactComponent as ImageProfes } from '../../../assets/images/jobDetail/profes.svg';
import { ReactComponent as ImageDegree } from '../../../assets/images/jobDetail/degree.svg';
import { ReactComponent as ImageOpenManpower } from '../../../assets/images/jobDetail/openManpower.svg';
import { ReactComponent as ImageGender } from '../../../assets/images/jobDetail/gender.svg';
import { ReactComponent as ImageAge } from '../../../assets/images/jobDetail/age.svg';
import { ReactComponent as ImageExp } from '../../../assets/images/jobDetail/exp.svg';
import { Tooltip } from 'antd';

const ContentLeft = (props) => {
    const { job } = props

    const data = [
        {
            icon: <ImageOpenManpower />,
            title: 'จำนวนที่รับ',
            key: 'remainingManpower'
        },
        {
            icon: <ImagePosition />,
            title: 'ระดับตำแหน่งงาน',
            key: 'positionManageName'
        },
        {
            icon: <ImageGender />,
            title: 'เพศ',
            key: 'gender'
        },
        {
            icon: <ImageAge />,
            title: 'อายุ',
            key: 'age'
        },
        {
            icon: <ImageDegree />,
            title: 'ระดับการศึกษา',
            key: 'degreeName'
        },
        {
            icon: <ImageProfes />,
            title: 'ใบประกอบวิชาชีพ',
            key: 'professionalLicenseName'
        },
        {
            icon: <ImageExp />,
            title: 'ประสบการณ์',
            key: 'experience'
        }
    ]

    const getValue = (item) => {
        let value = job[item.key]
        if (item.key === 'remainingManpower') {
            if (job['isNotSpecifyManpower'] === true) {
                value = 'ไม่ระบุ'
            } else {
                value = (value ?? 0) + ' อัตรา'
            }
        }
        else if (item.key === 'degreeName') {
            const _fieldName = job['fieldName'] && job['fieldName'].length > 0 ? job['fieldName'].join(',') : job['fieldName']
            const _degreeName = value && value.length > 0 ? (value.join(',')) + (job['isRelatedDegree'] === true ? (' หรือเทียบเท่า' + (_fieldName.length > 0 ? ',' : '')) : '') : value
            value = _degreeName + ' ' + _fieldName + (job['isRelatedField'] === true ? ' หรือสาขาที่เกี่ยวข้อง' : '')
        } else if (item.key === 'experience') {
            value += ' ปีขึ้นไป'
        } else if (item.key === 'age') {
            value = `${job['ageFrom']} - ${job['ageTo']} ปี`
            if (job['ageFrom'] && job['ageTo']) {
                value = `${job['ageFrom']} - ${job['ageTo']} ปี`
            } else if (job['ageFrom'] && !job['ageTo']) {
                value = `${job['ageFrom']} ปีขึ้นไป`
            } else if (!job['ageFrom'] && job['ageTo']) {
                value = `ไม่เกิน ${job['ageTo']} ปี`
            }
        } else if (item.key === 'gender') {
            if (job['gender'] === 'female') value = `หญิง`
            else if (job['gender'] === 'male') value = `ชาย`
            else value = `ไม่จำกัดเพศ`
        } else if (item.key === 'professionalLicenseName' && value && value.length > 0) {
            value = value.join(',')
        } else if (item.key === 'positionManageName') {
            const _emplevel = job['empLevel']
            value = value + ' ' + _emplevel
        }
        return value
    }

    const isMobile = window.innerWidth <= 768;

    return (
        <div className='content-left'>
            <div className="title text-center">รายละเอียดการรับสมัคร</div>
            <div className="detail w-full h-full">
                {
                    data.map((item, index) => {
                        const value = getValue(item)
                        if (item.title === 'ใบประกอบวิชาชีพ' && job[item.key]?.length === 0) {
                            return <div key={index}></div>
                        } else {
                            return (
                                <div className="detail-data flex" key={index}>
                                    <div className="icon">
                                        {item.icon}
                                    </div>
                                    <div className="description flex flex-col w-full pr-8">
                                        <div className="desc description-title">
                                            {item.title}
                                        </div>
                                        <Tooltip title={value} trigger={isMobile ? 'click' : 'hover'}>
                                            <div className="desc description-data line-clamp-2"> {value}</div>
                                        </Tooltip>
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </div>
    )
}

export default ContentLeft